module.exports = __webpack_public_path__ + "static/media/termsOfUse.f5a23f6f.pdf";